import { render, staticRenderFns } from "./ProfileReadOnly.vue?vue&type=template&id=2a29ac0d&scoped=true&"
import script from "./ProfileReadOnly.vue?vue&type=script&lang=js&"
export * from "./ProfileReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ProfileReadOnly.vue?vue&type=style&index=0&id=2a29ac0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29ac0d",
  null
  
)

export default component.exports